import { render, staticRenderFns } from "./LoyaltyStampDot.vue?vue&type=template&id=52590aea&scoped=true&lang=pug&"
import script from "./LoyaltyStampDot.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampDot.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyStampDot.vue?vue&type=style&index=0&id=52590aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52590aea",
  null
  
)

export default component.exports